import 'jquery';
import Swiper, {Autoplay, Navigation, Keyboard}  from 'swiper';

Swiper.use([Autoplay, Navigation, Keyboard]);

const navigation = (el) => {
  const swiperClass = {
    nextEl: '.' + el + '-swiper__button--next',
    prevEl: '.' + el + '-swiper__button--prev',
  }
  return swiperClass;
}

const defaultBreakpoints = {
    4000: {
        slidesPerView: 3,
    },
    993: {
        slidesPerView: 3,
    },
    992: {
        slidesPerView: 2,
    },
    565: {
        slidesPerView: 2,
        centeredSlides: true,
        centeredSlidesBounds: true,
    },
    0: {
        slidesPerView: 1,
        centeredSlides: true,
        centeredSlidesBounds: true,
    },
}

$(window).on('load', function() {
    new Swiper('.home-swiper', {
        loop: true,
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        navigation: navigation('home-swiper'),
        autoplay: {
            delay: 5000,
        },
    });
    new Swiper('.image-swiper', {
        loop: true,
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        navigation: navigation('image-swiper'),
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
        autoplay: {
            delay: 5000,
        },
    });
    new Swiper('.floorplan-swiper', {
        loop: true,
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        navigation: navigation('floorplan-swiper'),
        keyboard: {
            enabled: true,
        },
        autoplay: {
            delay: 5000,
        },
    });
    new Swiper('.related-swiper', {
        loop: false,
        slidesPerView: 3,
        observer: true,
        observeParents: true,
        keyboard: {
            enabled: true,
        },
        spaceBetween: 30,
        breakpoints: {
            4000: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            993: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            565: {
                slidesPerView: 2,
                centeredSlides: true,
                centeredSlidesBounds: true,
                spaceBetween: 10,
            },
            0: {
                slidesPerView: 1,
                centeredSlides: true,
                centeredSlidesBounds: true,
                spaceBetween: 10,
            },
        },
    });
    new Swiper('.partners-swiper', {
        loop: false,
        slidesPerView: 3,
        observer: true,
        observeParents: true,
        keyboard: {
            enabled: true,
        },
        spaceBetween: 30,
        breakpoints: defaultBreakpoints,
        navigation: navigation('partners'),
    });
    new Swiper('.review-swiper', {
        loop: true,
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        autoHeight: true,
        autoplay: {
            delay: 5000,
        },
        navigation: navigation('review'),
    });
    new Swiper('.team-swiper', {
        loop: false,
        slidesPerView: 3,
        observer: true,
        observeParents: true,
        navigation: navigation('team'),
        keyboard: {
            enabled: true,
        },
        spaceBetween: 30,
        breakpoints: defaultBreakpoints,
    });
    new Swiper('.keurmerken-swiper', {
        loop: false,
        slidesPerView: 6,
        observer: true,
        observeParents: true,
        navigation: navigation('keurmerken'),
        keyboard: {
            enabled: true,
        },
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 30,
        breakpoints: {
            4000: {
                slidesPerView: 6,
            },
            993: {
                slidesPerView: 6,
            },
            992: {
                slidesPerView: 3,
            },
            565: {
                slidesPerView: 3,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
            0: {
                slidesPerView: 2,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
        },
    });
});
